import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

import sistemaStore from "./sistema";
import usuarioStore from "./usuario";
import clientesStore from "./clientes";
import locaisStore from "./locais";
import pedidosStore from "./pedidos";
import baseStore from "./base";
import relatoriosStore from "./relatorios";
import insumosStore from "./insumos";
import formacaoCargaStore from "./formacaoCarga";
import syncStore from "./sync";
import visitaTecnicaStore from "./visitaTecnica";

export default new Vuex.Store({
  modules: {
    sistema: sistemaStore,
    usuario: usuarioStore,
    clientes: clientesStore,
    locais: locaisStore,
    pedidos: pedidosStore,
    base: baseStore,
    relatorios: relatoriosStore,
    insumos: insumosStore,
    formacaoCarga: formacaoCargaStore,
    sync: syncStore,
    visitaTecnica: visitaTecnicaStore,
  },
  plugins: [
    createPersistedState({
      paths: [
        "sistema.atalhos",        // Importante para offline
        "sistema.sincronizacoes", // Importante para offline
        "sistema.drawer",         // Opcional: lembrar se o menu estava aberto
        // "usuario"              // Se você persistir o usuário também
      ],
    }),
  ],
});
